<div class="row">
  <div class="col-12">
    <textarea class="form-control form-control-sm bg_gray" [(ngModel)]="dataFeed" style="height:25vh"></textarea>
  </div>
</div>
